import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-html-print',
  templateUrl: './html-print.component.html',
  styleUrls: ['./html-print.component.css']
})
export class HtmlPrintComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
